<template>
  <div id="list_quote">
    <Header />
    <LeftNav />
    <main id="page-wrap">
      <b-container fluid>
        <LeadFilterBar />
        <LeadListTable />
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/layout/AppHeader.vue";
import Footer from "@/components/common/layout/AppFooter.vue";
import LeadListTable from "@/components/common/layout/LeadListTable";
import LeftNav from "@/components/common/layout/AppLeftNav";
import LeadFilterBar from "@/components/vuetable/LeadFilterBar.vue";

export default {
  name: "list_lead",
  components: {
    Header,
    Footer,
    LeftNav,
    LeadListTable,
    LeadFilterBar
  }
};
</script>

<style scoped>
.row-top-list {
  margin-top: 40px;
}
</style>

<i18n>
{
  "en": {
    "search_panel": "Search Panel",
    "list_quotaion": "Lead List"
  },
  "si": {
    "search_panel": "සෙවුම් පැනලය",
    "list_quotaion": "ලැයිස්තු උපුටා දැක්වීම"
  }
}
</i18n>
